/**
 * Custom hook: User management actions (add / delete / change password / permissions).
 */

import axios from 'axios';
import { API } from '../utils/constants';

export const useUserActions = ({
  location,
  newUsername,
  setNewUsername,
  newPassword,
  setNewPassword,
  newRole,
  editPassword,
  setEditPassword,
  setEditingUserId,
  editingPermissions,
  setEditingPermissions,
  setEditingPermissionsUserId,
  refresh,
}) => {
  const handleAddUser = async () => {
    if (!newUsername.trim() || !newPassword.trim() || newPassword.length < 4) {
      alert('Wpisz login i hasło (min. 4 znaki).');
      return;
    }
    try {
      await axios.post(`${API}/users`, { username: newUsername.trim(), password: newPassword, role: newRole, location });
      setNewUsername('');
      setNewPassword('');
      refresh();
    } catch (e) {
      alert(e.response?.data?.detail || 'Błąd.');
    }
  };

  const handleDeleteUser = async (userId, username) => {
    if (!await window.confirm(`Usunąć użytkownika "${username}"?`)) return;
    try {
      await axios.delete(`${API}/users/${userId}`);
      refresh();
    } catch (e) {
      alert(e.response?.data?.detail || 'Błąd.');
    }
  };

  const handleChangeUserPassword = async (userId) => {
    if (!editPassword.trim() || editPassword.length < 4) {
      alert('Hasło min. 4 znaki.');
      return;
    }
    try {
      await axios.put(`${API}/users/${userId}/password`, { newPassword: editPassword });
      setEditingUserId(null);
      setEditPassword('');
      alert('Hasło zmienione.');
    } catch (e) {
      alert(e.response?.data?.detail || 'Błąd.');
    }
  };

  const handleUpdateUserPermissions = async (userId) => {
    try {
      await axios.put(`${API}/users/${userId}/permissions`, { permissions: editingPermissions });
      setEditingPermissionsUserId(null);
      setEditingPermissions([]);
      refresh();
      alert('Uprawnienia zaktualizowane.');
    } catch (e) {
      alert(e.response?.data?.detail || 'Błąd.');
    }
  };

  const togglePermission = (permission) => {
    if (editingPermissions.includes(permission)) {
      setEditingPermissions(editingPermissions.filter((p) => p !== permission));
    } else {
      setEditingPermissions([...editingPermissions, permission]);
    }
  };

  return {
    handleAddUser,
    handleDeleteUser,
    handleChangeUserPassword,
    handleUpdateUserPermissions,
    togglePermission,
  };
};
